import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { dutchTemplate } from '../../../utils/variables';
import styles from './style';

const STORAGE_KEY = 'app_banner_dismissed';
const DEEP_LINK_SCHEME = 'test.c360.myggonline.app://';
// Android Chrome requires intent:// format to reliably open a custom URI scheme
const ANDROID_INTENT_URL = 'intent://#Intent;scheme=test.c360.myggonline.app;package=com.fatum.mobile;end';

const ua = () => window.navigator.userAgent;
const isAndroid = () => /android/i.test(ua());
const isIOS = () => /iphone|ipad|ipod/i.test(ua());

const useStyles = makeStyles(styles);

const AndroidBanner = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isDutch = theme?.template === dutchTemplate;
    const [config, setConfig] = useState(null);

    useEffect(() => {
        if (!isDutch) return;
        if (sessionStorage.getItem(STORAGE_KEY)) return;
        if (isAndroid() || isIOS()) {
            setConfig({ description: 'Guardian Group · Open in app' });
        }
    }, [isDutch]);

    const handleDismiss = () => {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        setConfig(null);
    };

    const handleOpen = () => {
        // Intent URL is required for Android Chrome; custom scheme works on iOS
        window.location.href = isAndroid() ? ANDROID_INTENT_URL : DEEP_LINK_SCHEME;
    };

    if (!config) return null;

    return (
        <div className={classes.banner}>
            <button type="button" className={classes.closeButton} onClick={handleDismiss} aria-label="Dismiss">
                ✕
            </button>
            <img
                src="/images/ggIconOnly.png"
                alt="GG Online"
                className={classes.icon}
            />
            <div className={classes.info}>
                <div className={classes.appName}>GG Online</div>
                <div className={classes.description}>{config.description}</div>
            </div>
            <button
                type="button"
                className={classes.openButton}
                onClick={handleOpen}
            >
                Open
            </button>
        </div>
    );
};

export default AndroidBanner;
